// ======================================================================
// File Name       : ContentSingleQuestionConfirmDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Modal, Form, Col, Button } from 'react-bootstrap';
import { MESSAGE_TYPE, MESSAGE_TIME_OUT, MODAL_SIZE } from '../../constants/index';
import ContentQuestionDetail from './ContentQuestionDetail';

class ContentSingleQuestionConfirmDialog extends React.Component {
  render() {
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
    const {
      questionKind,
      questionSecernId,
      questionTitle,
      questionContent,
      questionUseForm,
      answerFormula,
      optionMarkKind,
      inputLimitType,
      inputLimit,
      optionRandomUse,
      correctAnswer,
      correctNumber,
      optionArray,
      subQuestionArray,
      questionViewDirection,
      absolutePoint,
      limitTime,
      sankakuUseDistinct,
      questionZipFileName,
      explanationUse,
      explanationHtmlUse,
      explanationContent,
      explanationZipFileName,
      hintUse,
      hintHtmlUse,
      hintContent,
      hintZipFileName,
      answerInfo,
      questionAttributeList,
    } = this.props;
    return (
      <Modal
        show={this.props.showModal}
        size={MODAL_SIZE.lg}
        style={style}
      >
        <Modal.Header onHide={this.props.onCancel} closeButton>
          <Modal.Title className="text-center">
            以下の内容で登録します
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="padding-10">
          <Col sm={12}>
            <ContentQuestionDetail
              questionKind={parseInt(questionKind, 10)}
              questionSecernId={questionSecernId}
              questionTitle={questionTitle}
              questionContent={questionContent}
              answerFormula={parseInt(answerFormula, 10)}
              optionMarkKind={optionMarkKind}
              inputLimitType={inputLimitType}
              inputLimit={inputLimit}
              optionRandomUse={optionRandomUse ? 1 : 0}
              correctAnswer={correctAnswer}
              correctNumber={correctNumber}
              optionArray={optionArray}
              subQuestionArray={subQuestionArray}
              questionViewDirection={questionViewDirection}
              absolutePoint={absolutePoint}
              limitTime={limitTime}
              sankakuUseDistinct={sankakuUseDistinct ? 1 : 0}
              isDetail={false}
              questionZipFileName={questionZipFileName}
              questionUseForm={questionUseForm}
              explanationUse={explanationUse}
              explanationContent={explanationContent}
              explanationHtmlUse={explanationHtmlUse}
              explanationZipFileName={explanationZipFileName}
              hintUse={hintUse}
              hintHtmlUse={hintHtmlUse}
              hintContent={hintContent}
              hintZipFileName={hintZipFileName}
              answerInfo={answerInfo}
              isShowConfirm
              questionAttributeList={questionAttributeList}
            />
          </Col>
        </Modal.Body>
        <Modal.Footer className="text-center">
          <Button variant="default" className="btn-96 margin-10" onClick={this.props.onCancel}>
            キャンセル
          </Button>
          <Button variant="primary" className="btn-96 margin-10" onClick={this.props.onOK}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ContentSingleQuestionConfirmDialog;
